// extracted by mini-css-extract-plugin
module.exports = {"top":"Collapse_top_1JCRv","title":"Collapse_title_C6DRw","_active":"Collapse__active_18pcF","icon":"Collapse_icon_3Aum_"};